function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 12869.3,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M42898 15908l64343 0 90079 90079m-114709 -64343l-52583 0c-7104,0 -12866,5762 -12866,12869l0 52573c-3,3411 1352,6686 3764,9102l78594 78610c3093,3093 7545,4403 11822,3476 4277,-927 7788,-3962 9325,-8058l12312 -32755 32762 -12292c4095,-1537 7130,-5049 8058,-9325 927,-4277 -383,-8729 -3476,-11822l-78620 -78610c-2412,-2412 -5681,-3764 -9092,-3768zm-26844 35388c-1777,0 -3217,1443 -3217,3220 0,1777 1440,3217 3217,3217 1777,0 3217,-1440 3217,-3217 3,-856 -334,-1676 -940,-2279 -603,-603 -1423,-940 -2276,-940"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 214476 214476",
    className: "icon",
    style: {
      "height": "1em",
      "width": "1em"
    }
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/tags.3a1a952a.svg";
export { SvgComponent as ReactComponent };